<template>
  <div class="col-lg-12">
    <div class="row">
      <div class="col-11">
        <button class="btn waves-effect waves-light btn-success" data-toggle="modal" data-target="#fertilizerModal" data-whatever="@getbootstrap">
          <i class="fas fa-plus" />&nbsp; Fertilizer
        </button>
      </div>
      <div class="col-1 text-right p-l-0">
        <div class="form-group">
          <select id="year" v-model="year" class="form-control" name="year" @change="yearChangeHandler">
            <option v-for="year in yearList" :key="index" :value="year">
              {{ year }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div v-if="inputList.fertilizer && inputList.fertilizer.length>0" class="table-responsive">
      <table class="table no-wrap v-middle">
        <thead>
          <tr class="border-0">
            <th class="border-0">
              Name
            </th>
            <th class="border-0">
              Brand
            </th>
            <th class="border-0">
              Amount
            </th>
            <th class="border-0">
              Purchase Price
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(fertilizer, index) in inputList.fertilizer" :key="index">
            <td>{{ fertilizer.name }}</td>
            <td>{{ fertilizer.brand }}</td>
            <td>{{ fertilizer.amount }} {{ fertilizer.amount_units }}</td>
            <td>{{ fertilizer.price_amount }} {{ fertilizer.price_units }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="card-header p-l-0">
      <h4 class="card-title text-muted">
        No fertilizers are added for this farm for the selected year.
      </h4>
    </div>
    <fertilizer-modal :prop-year="year" />
  </div>
</template>

<script>
import FertilizerModal from './modals/FertilizerModal';

export default {
  name: 'Fertilizer',
  components: { FertilizerModal },
  data() {
    return {
      inputList: {},
      yearList: [],
      year: (new Date()).getFullYear()
    };
  },
  mounted() {
    this.getInputList();
  },
  methods: {
    async getInputList() {
      const reply = await this.$api.get('/growers/inputs', {
        params: {
          year: this.year
        }
      });
      this.inputList = reply.data;
      const currentYear = (new Date()).getFullYear();
      this.yearList = [];
      for (var i = 0; i < 5; i++) {
        this.yearList.push(parseInt(currentYear) + i);
      }
    },
    handleSubmit() {
    },
    async save() {
    },
    reset() {
    },
    yearChangeHandler() {
      this.getInputList();
    }
  }
}
</script>

<style scoped>
</style>
